import React from 'react';

export const pageMeta = {
  "name": "Object Destructuring",
  "link": "/javascript/objects/destructuring"
};

export default function JavascriptObjectsDestructuring() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">Object Destructuring</h2>
      <p>Route: /javascript/objects/destructuring</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
